export const timeZones = {
  read: () => $.getJSON(AdminRoutes.adminTimeZonesPath())
};
